export default {"src":"/_next/static/media/DMCA.da810598.svg","height":44,"width":85,"blurWidth":0,"blurHeight":0};